<template>
  <div style="margin: 10px">
    <v-form>
      <v-card>
        <div class="headline dialog-header" v-if="showDialogHeader">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">
              {{ $t(formName) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn @click="onCancel" icon style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        ">
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm12 md6 style="padding: 0 20px">
              <p class="font-weight-bold">
                Vụ nuôi: {{ cropCode }}
              </p>
            </v-flex>
            <v-flex xs12 sm12 md6 style="padding: 0 20px">
              <i-datepicker
                  label="Ngày cập nhât"
                  v-model="createItem.exportDate"
                  @change="onChangeExportDate()"
              />
            </v-flex>
            <v-flex xs12 sm12 md6 style="padding: 0 20px">
                <!-- <c-textbox v-model="createItem.totalFood" label="Số lượng thức ăn" style="text-align: right"/> -->
                <v-text-field
                    :data-vv-as="$t('Số lượng thức ăn')"
                    :error-messages="errors.first('totalFood')"
                    :label="$t('Số lượng thức ăn')"
                    name="totalFood"
                    v-model="createItem.totalFood"
                    v-validate="'required|decimal'"
                />
            </v-flex>
            <v-flex xs12 sm12 md6 style="padding: 0 20px">
                <!-- <c-textbox v-model="createItem.seedIntNumber" label="Số lượng giống" style="text-align: right"/> -->
                <v-text-field
                    :data-vv-as="$t('Số lượng giống')"
                    :error-messages="errors.first('seedIntNumber')"
                    :label="$t('Số lượng giống')"
                    name="seedIntNumber"
                    v-model="createItem.seedIntNumber"
                    v-validate="'required|numeric'"
                />
            </v-flex>
            <!-- <div style="padding: 20px">Người cập nhật cuối: <strong>{{ lastUserName }}</strong></div> -->
          </v-layout>


        </v-card-text>
        <v-card-actions style="padding: 0 30px">
          <v-spacer/>
          <v-btn color="primary" @click="onSave" :disabled="loading">
            {{ $t("lang.common.update") }}
          </v-btn>
          <v-btn color="error" @click="onCancel">
            <v-icon dark left>cancel</v-icon>
            {{ $t("lang.common.cancel") }}
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-layout wrap>
            <v-flex lg12 md12 sm12 xs12>
              <c-search-form
                  :displayToolbar="false"
                  :rows-per-page-items="[10, 20, 50]"
                  form-name="Lịch sử"
                  :fields="fields"
                  key-property="exportRequestTotalId"
                  :search-url="searchUrl"
                  form-type="intable"
                  ref="tableData"
                  :reload="timeReload"
                  :deleteMulti="false"
                  :acceptDelete="false"
              />
            </v-flex>
          </v-layout>

        </v-card-text>
      </v-card>

    </v-form>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import {message} from "../../../shared/message";
import {areaContants, roleConstants, requestConstants, cateContants} from "@/constants";
import MaterialList from "../export_request/component/MaterialList";
import CTextboxFloat from "@/components/form/TextboxFloat";
import CTextbox from "@/components/form/Textbox";
import CSearchForm from "@/components/form/ManageForm";

export default {
  name: "export-request-total-edit",
  components: {
    CSearchForm,
    CTextbox,
    CTextboxFloat, IDatepicker
  },
  props: {
    cropId: {
      type: [String, Number],
      default: "-1"
    },
    showDialogHeader: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      cropIdIn: "-1",
      formName: "Cập nhật số lượng đã xuất",
      loading: false,
      searchUrl: "",
      cropCode: '',
      areaCode: '',
      crop: '',
      lstMaterialType: [],
      lstMaterial: [],
      materialDlg: false,
      lastUserName: '',
      createItem: {
        cropId: '',
        totalFood: '',
      },
      timeReload: 0,
      hiddenFields: {
        cropId: undefined,
      },
      allowUpdate: true,
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: "exportDate",
          text: "Ngày cập nhật",
          dateFormat: 'dd/MM/yyyy',
          type:"datetime",
          search: false,
          headerStyle: "text-align:center",
        },
        {
          value: "totalFood",
          text: "Số lượng thức ăn",
          search: false,
          headerStyle: "text-align:center",
        },
        {
          value: "seedIntNumber",
          text: "Số lượng con giống",
          search: false,
          headerStyle: "text-align:center",
        },
        {
          value: "userName",
          text: "Người cập nhật",
          search: false,
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    if (this.cropId != undefined && this.cropId != "" && this.cropId != "-1") {
      this.cropIdIn = this.cropId;
    } else if (this.$route.params.cropId != undefined && this.$route.params.cropId != "") {
      this.cropIdIn = this.$route.params.cropId;
    }
    // this.createItem.exportDate = this.currentDate();
    //this.getMaterialType();
  },
  computed: {},
  watch: {
    cropId: function (value) {
      this.cropIdIn = value;
    },
    cropIdIn: function (value) {
      this.searchUrl= "/exportRequestTotal/search/cropId/" + value;
      //this.timeReload = Math.random();
      this.getExportRequestTotal(value);

    },
  },
  methods: {
    getExportRequestTotal(cropId) {
      if (cropId != -1) {
        axios
            .post(
                process.env.VUE_APP_API_URL + "/exportRequestTotal/search?pageSize=-1&page=-1",
                {cropId: cropId, exportDate: this.createItem.exportDate}
            )
            .then((data) => {
              if (data.items) {
                const exportRequestTotal = data.items[0];
                this.getCrop(cropId);
                console.log("exportRequestTotal", exportRequestTotal);
                this.createItem.cropId = cropId;
                if (exportRequestTotal) {
                  this.createItem = exportRequestTotal;
                } else{
                  this.createItem = Object.assign(this.createItem, {"totalFood": "", "seedIntNumber": ""});
                }

              }
            });
      }
    },
    onChangeExportDate() {
      this.getExportRequestTotal(this.cropIdIn);
    },
    onSave() {
      this.$validator.validate().then((valid) => {
          if (!valid) {
              message.error(this.$t("lang.common.validate_fail"));
              return;
          }

          const createItem = this.createItem;
          this.loading = true;
          axios
              .post(process.env.VUE_APP_API_URL + "/exportRequestTotal/save", createItem)
              .then(
                  (data) => {
                    if (data.success) {
                      message.success(
                          this.$t("lang.common.save_success")
                      );
                      this.$router.go(0)
                    } else {
                      message.error(this.$t(data.description));
                    }
                    this.loading = false;
                  },
                  (error) => {
                    this.loading = false;
                    console.log(error);
                  }
              );
      });
    },
    onCancel() {
      this.searchUrl = "";
      this.$router.push({path: `/categorylist/crop`, query: this.$route.query});
    },
    getCrop(cropId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1",
          {cropId: cropId}
      )
          .then((data) => {
            if (data.items && data.items[0] != undefined) {
              this.cropCode = data.items[0].code;
              this.lastUserName = data.items[0].exportTotalUserName;
            }
          });
    },
    currentDate() {
      const currentDate = moment().format('YYYY-MM-DD');
      return currentDate;
    },


  },

  destroyed() {
  },
};
</script>
